import { mailContractUrlApi } from "../../../api/client";

/**
 * Opens the legacy APEX "Mail contract to Dealer" page in a new tab. The BFF only builds the
 * deep link (`from=actions`); it sends no mail. The tab is opened synchronously on click and
 * navigated once the URL resolves, so the async fetch doesn't trip the popup blocker.
 * @param {string} approvalId - The approval/deal ID.
 * @returns {Promise<void>} Resolves once the tab is navigated; rejects (and closes the tab) on failure.
 */
export async function openMailContract(approvalId: string): Promise<void> {
  const popup = window.open("", "_blank");
  try {
    const { data } = await mailContractUrlApi.getMailContractUrl(approvalId, "actions");
    const { protocol } = new URL(data.apexUrl, window.location.origin);
    if (protocol !== "https:" && protocol !== "http:") {
      throw new Error("Unexpected mail-contract URL protocol");
    }
    if (popup) {
      // Setting opener to null (not undefined) is what severs the link to this window.
      // eslint-disable-next-line unicorn/no-null
      popup.opener = null;
      popup.location.href = data.apexUrl;
    } else {
      window.open(data.apexUrl, "_blank", "noopener");
    }
  } catch (error) {
    popup?.close();
    throw error;
  }
}
